import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SubTitleText= styled(Typography)(({ theme }) => ({
    fontSize: "24px",
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.secondary.dark,
}));
